import {Trans} from '@lingui/macro';
import React from 'react';

import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ButtonVariantsEnum} from '../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {OkCancelDialog} from '../../../../components/common/dialogs/okCancelDialog';

/*
 * Type.
 */

interface DeleteDialogProps {
  onOk: Handler;
  onCancel: Handler;
}

/*
 * Component.
 */

export const DeleteDialog = ({onOk, onCancel}: DeleteDialogProps) => (
  <OkCancelDialog
    title={<Trans id="rule-delete-dialog-title">Delete 1 rule</Trans>}
    okButtonLabel={<Trans id="rule-delete-dialog-confirm">Delete permanently</Trans>}
    onOkClick={onOk}
    onRequestClose={onCancel}
    okButtonVariant={ButtonVariantsEnum.DANGER}
  >
    <Trans id="rule-disable-delete-dialog-message">
      This rule will be permanently deleted in Front.
      <br />
      This cannot be undone.
    </Trans>
  </OkCancelDialog>
);
